module.exports = __webpack_public_path__ + "static/media/vehicle-img.75b38377.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/WhereIsMyVin/vehicle-img.png
// module id = 1956
// module chunks = 7